import React from 'react';
import { Routes, Route, HashRouter, Link } from 'react-router-dom';
import './App.css';
import { AISafetyPage } from './posts/AISafety';
import { KoopmanPage } from './posts/Koopman';
import { SearchAttackPage } from './posts/SearchAttack';
import ScrambledEmail from './components/ScrambledEmail';
import { RustPage } from './posts/Rust';
import { MPCPage } from './posts/MPC';
import { SafeSteer } from './posts/SafeSteer';
import { TrueSearcherPage } from './posts/TrueSearcher';
import { KoopmanCBFPage } from './posts/KoopmanCBF';
import { KoopmanHighDimensionPage } from './posts/KoopmanHighDimension';

const posts = [
  { title: 'Minimal Safe Steer', path: '/steer' },
  { title: 'AI Safety and Optimal Control', path: '/ai' },
  { title: 'True Searcher', path: '/search' },
  { title: 'Rust cheat sheet', path: '/rust' },
];

const HomePage: React.FC<{}> = () => {
  return (
    <main>
      <h1>Blog Posts</h1>
      <div className="blog-list">
        {posts.map((post) => (
          <Link key={post.path} to={post.path}>
            {post.title}
          </Link>
        ))}
      </div>
    </main>
  );
};

const AboutPage: React.FC<{}> = () => (
  <main>
    <h1>About</h1>
    <p>Neil Lugovoy</p>
    <ScrambledEmail email='nflugovoy@berkeley.edu' />
    <p>My blog about math, physics, and computer science.</p>
    <a href={"https://scholar.google.com/citations?user=elP1VOQAAAAJ&hl=en"}>Google Scholar</a>
  </main>
);

const KubernetesPage: React.FC<{}> = () => (
  <main>
    <h1>My Kubernetes commands cheatsheet</h1>
    <p>
      Here's some of the K8s commands I've found the most useful. I'll add to this list as I encounter more.
    </p>
  </main>
);

const DbPage: React.FC<{}> = () => {
  return (<main>
    <h1>Database</h1>
    <p>
      I built a database and I am turning it into an interactive guide. Check it out here: <a href="https://www.playgrounddb.com">playgrounddb.com</a>
    </p>
  </main>);
}

function App() {
  React.useEffect(() => {
    document.title = 'neil.ski';
  }, []);

  return (
    <HashRouter>
      <header>
        <h1>neil.ski</h1>
        <nav>
          <Link style={{padding: "2px"}} to="/">Home</Link>
          <Link style={{padding: "2px"}} to="/about">About</Link>
        </nav>
      </header>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/kubernetes" element={<KubernetesPage />} />
        <Route path="/rust" element={<RustPage />} />
        <Route path="/mpc" element={<MPCPage />} />
        <Route path="/ai" element={<AISafetyPage />} />
        {/* <Route path="/koopman" element={<KoopmanPage />} /> */}
        <Route path="/koopman" element={<KoopmanHighDimensionPage />} />
        <Route path="/search_attack" element={<SearchAttackPage />} />
        <Route path="/steer" element={<SafeSteer/>} />
        <Route path="/search" element={<TrueSearcherPage/>} />
        <Route path="/db" element={<DbPage/>} />
        <Route path="/cbf" element={<KoopmanCBFPage/>} />
      </Routes>
    </HashRouter>
  );
}

export default App;